var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    _vm._g({ staticClass: "labeled-icon-wrapper" }, _vm.$listeners),
    [
      _c(
        "span",
        { staticClass: "icon" },
        [
          _vm._t("icon", function () {
            return [
              _vm.icon
                ? _c("KIcon", {
                    staticStyle: { top: "2px" },
                    attrs: {
                      icon: _vm.icon,
                      color: _vm.color || _vm.$themeTokens.text,
                    },
                  })
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
      _c("span", { staticClass: "label", style: _vm.labelStyle }, [
        _c(
          "span",
          { staticClass: "debug-warning", attrs: { dir: "auto" } },
          [
            _vm._t("default", function () {
              return [
                !_vm.labelEmpty
                  ? _c("span", [_vm._v(_vm._s(_vm.label))])
                  : _c("span", [_vm._v("​")]),
              ]
            }),
          ],
          2
        ),
      ]),
      _c(
        "span",
        { staticClass: "icon-after" },
        [
          _vm._t("iconAfter", function () {
            return [
              _vm.iconAfter
                ? _c("KIcon", {
                    staticStyle: { top: "2px" },
                    attrs: {
                      icon: _vm.iconAfter,
                      color: _vm.color || _vm.$themeTokens.text,
                    },
                  })
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }